module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "img_containerc"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Note"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Translator’s Note")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Foreword"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Foreword")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("by Roger Moorhouse")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Preface"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("CHAPTER 1")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Apprentice and Journeyman")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("CHAPTER 2")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("At the Reich Labour Camp")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("CHAPTER 3")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("How We Became Soldiers")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("CHAPTER 4")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("On Sick Leave")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("CHAPTER 5")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("To the Eastern Front")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("CHAPTER 6")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Rude Awakening")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("CHAPTER 7")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Forced Labour by the Sea of Azov")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("CHAPTER 8")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("An Unknown Destination")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("CHAPTER 9")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("The Escape")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("CHAPTER 10")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("An Endless Expanse")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("CHAPTER 11")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Shattered Hopes")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("CHAPTER 12")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Contact with the Homeland")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("CHAPTER 13")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Returning Home")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("CHAPTER 14")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("A Difficult Beginning")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132b06ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 69
// module chunks = 0